import React from 'react';
import { IndexRedirect } from '@americanexpress/one-app-router';
import ModuleRoute from 'holocron-module-route';
import updateLocaleFromRoute from './hooks/updateLocaleFromRoute';
import requireReconAuth from './hooks/requireReconAuth';
import requireAtWorkAuth from './hooks/useAtWorkAuth';
import ErrorPage from './components/ErrorPage';
import UnauthorizedErrorPage from './components/UnauthorizedErrorPage';
import GlobalErrorPage from './components/GlobalErrorPage';

const childRoutes = (store) => [
  <ModuleRoute
    key="rootModule"
    path=":locale/business/commercial/reconciliation/"
  >
    <IndexRedirect to="Welcome" />
    <ModuleRoute
      onEnter={updateLocaleFromRoute(store)}
    >
      <ModuleRoute
        key="root"
        moduleName="axp-commercial-reconciliation-wrapper"
      >
        <ModuleRoute
          key="interface-builder"
          path="file-builder"
          moduleName="axp-commercial-reconciliation-interface-builder"
        />
        <ModuleRoute
          key="ransaction-details"
          path="bta-intl/transaction-details"
          moduleName="axp-commercial-reconciliation-travel-data-international-transaction-details"
        />
        <ModuleRoute
          key="recon-web"
          path="recon-web"
          moduleName="axp-commercial-reconciliation-recon-web"
        />
        <ModuleRoute
          key="reconHeader"
          moduleName="axp-commercial-reconciliation-header"
        >
          <ModuleRoute>
            <ModuleRoute
              key="registration"
              path="registration"
              moduleName="axp-commercial-reconciliation-user-management"
            />
          </ModuleRoute>
          <ModuleRoute
            onEnter={requireAtWorkAuth(store)}
          >
            <ModuleRoute
              key="registrationWithProfile"
              path="registration/:scenario"
              moduleName="axp-commercial-reconciliation-user-management"
            />
          </ModuleRoute>
          <ModuleRoute path="registration/:scenario/unauthorizedError" component={UnauthorizedErrorPage} />
          <ModuleRoute path="registration/:scenario/error" component={ErrorPage} />
          <ModuleRoute
            onEnter={requireReconAuth(store)}
          >
            <ModuleRoute
              key="migration"
              path="migration"
              moduleName="axp-commercial-reconciliation-user-management"
            />
          </ModuleRoute>

          <ModuleRoute path="unauthorizedError" component={UnauthorizedErrorPage} />
          <ModuleRoute path="error" component={ErrorPage} />
          <ModuleRoute path="pageNotFound" component={GlobalErrorPage} />
          <ModuleRoute path="*" component={GlobalErrorPage} />
        </ModuleRoute>
      </ModuleRoute>
    </ModuleRoute>
  </ModuleRoute>,
  <ModuleRoute
    key="rootError"
    moduleName="axp-commercial-reconciliation-wrapper"
  >
    <ModuleRoute key="globalError" path="*" component={GlobalErrorPage} />
  </ModuleRoute>,
];

export default childRoutes;
